var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remote-working-view"},[(_vm.loaded)?_c('HubRemoteWorking',{attrs:{"name":"remote-working","overview":_vm.overview,"user":_vm.user}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }